/* eslint-disable sonarjs/cognitive-complexity */

import {
  BaSeButton,
  BaSeDialogContext,
  BaSeIcon,
  BaSeParagraph,
  BaSeTheme,
} from '@base/react';
import * as Sebrae from '@sebrae/react-core';
import React, { createContext } from 'react';
import { useMessage } from '../../../hooks/messages/useMessage';
import { useCityService } from '../../../hooks/services/city-service';
import { useClassService } from '../../../hooks/services/class-service';
import { cpfValidator } from '../../../utils/validators/cpf-validator';
import ModalConfirm from '../components/modal-confirm/modal-confirm';

export const FormContext = createContext();

export function FormProvider({ children }) {
  const { getListClass, creteNewInterviewForLandigpage } = useClassService();
  const { listCitiesByUf } = useCityService();
  const { showModal } = React.useContext(BaSeDialogContext);
  const { tokenInfo, isAuthenticated } = Sebrae.useAuth();
  const { navigateTo } = Sebrae.useSebraeRouter();
  const { handleError } = useMessage();
  const [acept, setAcept] = React.useState(false);
  const [nameClass, setNameClass] = React.useState('');

  const getUrl = React.useCallback(() => {
    const url = window.location.protocol + '//' + window.location.host;
    return url;
  }, []);

  const formatCpf = React.useCallback((value) => {
    const rawValue = value.replace(/\D/g, '');
    const formattedValue = rawValue.replace(
      /(\d{3})(\d{3})(\d{3})(\d{0,2})/,
      (match, p1, p2, p3, p4) => `${p1}.${p2}.${p3}-${p4}`.replace(/-$/, ''),
    );
    return formattedValue;
  }, []);

  const handleMenuClick = React.useCallback((sectionId) => {
    const section = document.getElementById(sectionId);
    const offset = 94;
    const elementPosition =
      section.getBoundingClientRect().top + window.pageYOffset;
    const offsetPosition = elementPosition - offset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth',
    });
  }, []);

  const navigateToCandidate = React.useCallback(
    (option) => {
      if (option) {
        navigateTo(`${getUrl()}/candidato?origem=portal`);
      }
    },
    [navigateTo, getUrl],
  );

  // const openDialogErrorValidation = React.useCallback(
  //   (message, hasRedirect) => {
  //     return showModal({
  //       actions: [],
  //       size: 'small',
  //       title: '',
  //       dismissible: true,
  //       dismissibleIconColor: BaSeTheme.colors.defaultColors.black,
  //       dismissibleIconType: 'tertiary',
  //       content: ({ closeModal, emitEvent }) => (
  //         <div
  //           style={{
  //             display: 'flex',
  //             flexDirection: 'column',
  //             alignItems: 'center',
  //             gap: 26,
  //             justifyContent: 'center',
  //           }}
  //         >
  //           <BaSeParagraph
  //             color={BaSeTheme.colors.institucionais.cinzaSebrae45}
  //           >
  //             <span
  //               color={BaSeTheme.colors.institucionais.cinzaSebrae45}
  //               dangerouslySetInnerHTML={{
  //                 __html: message,
  //               }}
  //             ></span>
  //           </BaSeParagraph>

  //           <BaSeButton
  //             borderRadius={'max'}
  //             value="Fechar"
  //             width="120px"
  //             onClick={() => {
  //               closeModal();
  //               navigateToCandidate(hasRedirect);
  //             }}
  //           />
  //         </div>
  //       ),
  //       onChooseAction: (action) => {},
  //     });
  //   },
  //   [showModal, navigateToCandidate],
  // );

  const [nextScreen, setNextScreen] = React.useState(false);

  //lista de classes
  const [classes, setClasses] = React.useState([]);

  //dados pessoais
  const [personalData, setPersonalData] = React.useState({
    name: '',
    cpf: '',
    email: '',
    contato: '',
  });

  React.useEffect(() => {
    if (isAuthenticated) {
      setPersonalData((prevDto) => ({
        ...prevDto,
        name: tokenInfo.name,
        cpf: formatCpf(tokenInfo.cpf),
        email: tokenInfo.email,
      }));
    }
  }, [isAuthenticated, formatCpf, tokenInfo]);

  const handleChangePersonalData = React.useCallback((name, value) => {
    setPersonalData((prevDto) => ({
      ...prevDto,
      [name]: value,
    }));
  }, []);

  const values = Object.values(personalData);
  const hasEmptyField = values.some((val) => !val?.trim());

  // PAGINAÇ˜AO
  const [pageIndex, setPageIndex] = React.useState(0);
  const [pageSize] = React.useState(10); // Tamanho fixo da página
  const [totalPages, setTotalPages] = React.useState(1);
  const [totalItems, setTotalItems] = React.useState(0);

  //seleciona o estado
  const [listUfs, setListUf] = React.useState([]);
  const [selectedUfOption, setSelectedUfOption] = React.useState(null);

  //seleciona o id da turma escolhida
  const [selectedIdClass, setSelectedIdClass] = React.useState(null);
  const [loadingClasses, setLoadingClasses] = React.useState(false);
  const getlistClassRoom = React.useCallback(
    async (dto) => {
      setLoadingClasses(true);
      try {
        const response = await getListClass(dto);
        if (response.total === 0) {
          setClasses([]);
          setSelectedIdClass(null);

          return;
        }
        setTotalItems(response.total);
        setTotalPages(Math.ceil(response.total / pageSize));
        setClasses(response.items);
        setSelectedIdClass(null);
      } catch (error) {
        setClasses([]);
        setSelectedIdClass(null);
      } finally {
        setLoadingClasses(false);
      }
    },
    [getListClass, pageSize],
  );

  //busca a cidade
  const [listCity, setListCity] = React.useState([]);
  const [selectedCityOption, setSelectedCityOption] = React.useState(null);
  const [selectCityIdForClass, setSelectCityIdForClass] = React.useState(null);

  const [interestWithoutClass, setInterestWithoutClass] = React.useState(false);
  const [interestCityOption, setInterestCityOption] = React.useState(null);

  const hasSelectedUf = !!JSON.parse(selectedUfOption)?.id;
  const hasSelectedCity = !!JSON.parse(selectedCityOption)?.id;
  const hasInterestCity = !!JSON.parse(interestCityOption)?.id;
  const isRegisteringInterest = hasSelectedUf && interestWithoutClass;

  const showInterestCity = isRegisteringInterest && !hasSelectedCity;
  const showPersonalDataForm = !!selectedIdClass || isRegisteringInterest;
  const showButtonStartInterview =
    !hasEmptyField && (!showInterestCity || hasInterestCity);

  //seleciona o id do empretec
  const [empretecId, setEmpretecId] = React.useState(null);
  const handleSelectEmpretec = React.useCallback(
    (id) => {
      const ufData = JSON.parse(selectedUfOption);
      if (ufData && ufData.label !== 'Selecione') {
        let dto = {
          pageIndex: 0,
          pageSize,
          sortField: 'className',
          sortType: 'ASC',
          cityName: '',
          ufInitials: ufData.sigla,
          moduleId: id,
        };
        const cityData = JSON.parse(selectedCityOption);
        if (cityData && cityData.label !== 'Selecione') {
          dto.cityName = cityData.label;
        }

        getlistClassRoom(dto);
      }
      setPageIndex(0);
      setAcept(false);
      setEmpretecId(id);
    },
    [getlistClassRoom, pageSize, selectedCityOption, selectedUfOption],
  );

  const handlePageChange = React.useCallback(
    (event) => {
      setPageIndex(Number(event.target.value) - 1);
      const cityData = JSON.parse(selectedCityOption);
      const ufData = JSON.parse(selectedUfOption);

      const { label = '' } = cityData || {};
      const cityName = label === 'Selecione' ? '' : label;

      getlistClassRoom({
        pageIndex: Number(event.target.value) - 1,
        pageSize,
        sortField: 'className',
        sortType: 'ASC',
        cityName,
        ufInitials: ufData.sigla || '',
        moduleId: empretecId,
      });
    },
    [
      selectedUfOption,
      selectedCityOption,
      getlistClassRoom,
      pageSize,
      empretecId,
    ],
  );

  const handleSelectClass = React.useCallback(
    (id) => {
      setSelectedIdClass(id === selectedIdClass ? null : id);
      setInterestWithoutClass(false);
    },
    [selectedIdClass],
  );

  const handleSelectUf = React.useCallback(
    (event) => {
      const ufData = JSON.parse(event.target.value);
      setSelectedUfOption(event.target.value);
      setSelectedCityOption(null);
      setInterestCityOption(null);
      setPageIndex(0);

      listCitiesByUf(ufData)
        .then((response) => {
          const newResponse = response.map((city) => {
            return {
              id: city.id,
              label: city.name,
              sigla: city.uf.initials,
            };
          });
          newResponse.unshift({
            id: 0,
            label: 'Selecione',
            sigla: 'Selecione',
          });
          setListCity(newResponse);
        })
        .catch((error) => {
          setListCity([]);
        });

      const dto = {
        pageIndex: 0,
        pageSize,
        sortField: 'className',
        sortType: 'ASC',
        cityName: '',
        ufInitials: ufData.sigla,
        moduleId: empretecId,
      };
      getlistClassRoom(dto);
    },
    [
      setSelectedUfOption,
      listCitiesByUf,
      pageSize,
      empretecId,
      getlistClassRoom,
    ],
  );
  const handleSelectCity = React.useCallback(
    (event) => {
      const cityData = JSON.parse(event.target.value);
      const ufData = JSON.parse(selectedUfOption);

      setSelectedCityOption(event.target.value);
      setPageIndex(0);

      const dto = {
        pageIndex: 0,
        pageSize,
        sortField: 'className',
        sortType: 'ASC',
        cityName: cityData.label === 'Selecione' ? '' : cityData.label,
        ufInitials: ufData.sigla,
        moduleId: empretecId,
      };
      getlistClassRoom(dto);
    },
    [pageSize, selectedUfOption, empretecId, getlistClassRoom],
  );

  const successMessage = selectedIdClass
    ? `Interesse registrado com sucesso na turma ${nameClass}!`
    : 'Interesse registrado com sucesso!';

  const openDialogConfirmUrban = React.useCallback(
    (hasRedirect) => {
      return showModal({
        actions: [],
        size: 'small',
        title: '',
        dismissible: true,
        dismissibleIconColor: BaSeTheme.colors.defaultColors.black,
        dismissibleIconType: 'tertiary',
        content: ({ closeModal, emitEvent }) => (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 26,
              justifyContent: 'center',
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 8,
              }}
            >
              <div style={{ backgroundColor: '#4FAD4F', borderRadius: 100 }}>
                <BaSeIcon
                  color="#fff"
                  description="Ícone de teste"
                  name="check"
                  size={20}
                />
              </div>
              <BaSeParagraph
                color={BaSeTheme.colors.institucionais.cinzaSebrae30}
                isBold
              >
                {successMessage}
              </BaSeParagraph>
            </div>

            <ModalConfirm tipo={empretecId} />

            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <BaSeButton
                borderRadius={'max'}
                value="Ok, vamos lá!"
                width="120px"
                onClick={() => {
                  if (hasRedirect) {
                    closeModal();
                    navigateToCandidate(hasRedirect);
                  }
                }}
              />

              {[1, 2, 3].includes(empretecId) && (
                <BaSeButton
                  borderRadius={'max'}
                  value="Deixar para outro momento"
                  type="secondary"
                  onClick={() => {
                    closeModal();
                  }}
                />
              )}
            </div>
          </div>
        ),
        onChooseAction: (action) => { },
      });
    },
    [showModal, successMessage, empretecId, navigateToCandidate],
  );

  const openDialogConfirm = React.useCallback(
    (empretecnAME, message) => {
      return showModal({
        actions: [],
        size: 'small',
        title: '',
        dismissible: true,
        dismissibleIconColor: BaSeTheme.colors.defaultColors.black,
        dismissibleIconType: 'tertiary',
        content: ({ closeModal, emitEvent }) => (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 26,
              justifyContent: 'center',
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 8,
              }}
            >
              <div style={{ backgroundColor: '#4FAD4F', borderRadius: 100 }}>
                <BaSeIcon
                  color="#fff"
                  description="Ícone de teste"
                  name="check"
                  size={20}
                />
              </div>
              <BaSeParagraph
                color={BaSeTheme.colors.institucionais.cinzaSebrae30}
                isBold
              >
                {successMessage}
              </BaSeParagraph>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <BaSeParagraph
                color={BaSeTheme.colors.institucionais.cinzaSebrae30}
              >
                {
                  message ? <p dangerouslySetInnerHTML={{ __html: message }} />
                    : ` Após registrar seu interesse, nossa equipe poderá entrar em
                contato para orientar sobre as próximas etapas do ${empretecnAME}`
                }

                .
              </BaSeParagraph>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <BaSeButton
                borderRadius={'max'}
                value="Fechar"
                width="120px"
                onClick={() => {
                  closeModal();
                }}
              />
            </div>
          </div>
        ),
        onChooseAction: (action) => { },
      });
    },
    [showModal, successMessage],
  );

  const MAP_EMPRETEC_NAME = React.useMemo(
    () => ({
      1: 'Empretec Urbano',
      2: 'Empretec Startup',
      3: 'Empretec Arena',
      4: 'Empretec Rural',
    }),
    []
  );


  const handleCreateInterview = React.useCallback(() => {
    const requiredFields = [
      { value: personalData.name, message: 'Informe o nome!' },
      { value: personalData.cpf, message: 'Informe o CPF!' },
      { value: personalData.email, message: 'Informe o e-mail!' },
      { value: personalData.contato, message: 'Informe o telefone!' },
    ];
    const emptyField = requiredFields.find(({ value }) => !value?.trim());
    if (emptyField) {
      handleError(emptyField.message);
      return;
    }

    if (personalData.contato.replace(/\D/g, '').length < 10) {
      handleError('Telefone inválido!');
      return;
    }

    if (showInterestCity && !hasInterestCity) {
      handleError('Informe a cidade!');
      return;
    }

    const ufParse = JSON.parse(selectedUfOption);
    const cityParse = JSON.parse(selectedCityOption);
    const interestCityParse = JSON.parse(interestCityOption);

    const cityId = selectedIdClass
      ? selectCityIdForClass
      : cityParse?.id || interestCityParse?.id;

    const DTO = {
      candidate: {
        cpf: personalData.cpf.replace(/[^a-zA-Z0-9]/g, ''),
        name: personalData.name,
      },
      sendEmail: true,
      city: {
        uf: {
          id: ufParse.id,
          label: ufParse.label,
          sigla: ufParse.sigla,
        },
        id: cityId,
      },
      email: personalData.email,
      phone: personalData.contato.replace(/[()\s-]/g, ''),
      module: {
        id: empretecId,
      },
      ...(selectedIdClass && { idClassRoom: selectedIdClass }),
    };

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(DTO.email)) {
      handleError('E-mail inválido!');
      return;
    }

    if (DTO.candidate.cpf.length < 11 || !cpfValidator(DTO.candidate.cpf)) {
      handleError('CPF inválido!');
      return;
    }

    if (!DTO.city.id) {
      handleError('Informe a cidade!');
      return;
    }

    creteNewInterviewForLandigpage(DTO)
      .then((response) => {
        const { redirect, message } = response?.resultValidation;
        if (redirect) {
          openDialogConfirmUrban(redirect);
        } else {
          openDialogConfirm(MAP_EMPRETEC_NAME[empretecId], message);
        }
      })
      .then((response) => {
        console.log(response)

        const emptyData = {
          name: '',
          cpf: '',
          email: '',
          contato: '',
        };
        if (!isAuthenticated) {
          setPersonalData(emptyData);
          setAcept(false);
        }
      })
      .catch((error) => handleError(error.message ?? 'Erro ao validar os dados!'));
  }, [
    MAP_EMPRETEC_NAME,
    creteNewInterviewForLandigpage,
    empretecId,
    handleError,
    hasInterestCity,
    interestCityOption,
    isAuthenticated,
    openDialogConfirm,
    openDialogConfirmUrban,
    personalData.contato,
    personalData.cpf,
    personalData.email,
    personalData.name,
    selectCityIdForClass,
    selectedCityOption,
    selectedIdClass,
    selectedUfOption,
    showInterestCity,
  ]);

  return (
    <FormContext.Provider
      value={{
        classes,
        handleChangePersonalData,
        showButtonStartInterview,
        pageIndex,
        pageSize,
        setPageIndex,
        totalPages,
        totalItems,
        listUfs,
        setListUf,
        selectedUfOption,
        setSelectedUfOption,
        getlistClassRoom,
        personalData,

        handleSelectCity,
        handleSelectUf,
        handleSelectClass,
        handlePageChange,
        handleSelectEmpretec,
        listCity,
        empretecId,
        selectedIdClass,
        selectedCityOption,
        handleCreateInterview,
        formatCpf,
        nextScreen,
        setNextScreen,

        handleMenuClick,
        selectCityIdForClass,
        setSelectCityIdForClass,
        acept,
        setAcept,
        setNameClass,
        loadingClasses,
        interestWithoutClass,
        setInterestWithoutClass,
        interestCityOption,
        setInterestCityOption,
        showInterestCity,
        showPersonalDataForm,
      }}
    >
      {children}
    </FormContext.Provider>
  );
}
